import { styled } from 'styled-components';

export const StyledSpan = styled.span`
  display: inline-block;
  width: 19px;
`;
